module.exports = __webpack_public_path__ + "static/media/deck-3-super.25148e89.png";